import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoRadPesquisaPreFaturaGfo({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'radpesquisaprefaturagfo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoRadPesquisaPreFaturaGfo({ payload }) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(api.delete, `radpesquisaprefaturagfo/${fatu_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoradpesquisaprefaturagfo, params } = payload;

    yield call(
      api.post,
      'radpesquisaprefaturagfo',
      operacaoradpesquisaprefaturagfo
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/radpesquisaprefaturagfo');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `radpesquisaprefaturagfo/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoradpesquisaprefaturagfo, params } = payload;

    yield call(
      api.put,
      'radpesquisaprefaturagfo',
      operacaoradpesquisaprefaturagfo
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/radpesquisaprefaturagfo');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'radpesquisaprefaturagfo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoradpesquisaprefaturagfo/RADPESQUISAPREFATURAGFO_IN_REQUEST',
    requestOperacaoRadPesquisaPreFaturaGfo
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturagfo/DELETE_RADPESQUISAPREFATURAGFO',
    deleteOperacaoRadPesquisaPreFaturaGfo
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturagfo/SUCCESS_REMOVE',
    requestOperacaoRadPesquisaPreFaturaGfo
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturagfo/STORE_RADPESQUISAPREFATURAGFO',
    store
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturagfo/FIND_RADPESQUISAPREFATURAGFO',
    find
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturagfo/UPDATE_RADPESQUISAPREFATURAGFO',
    update
  ),
  takeLatest(
    '@operacaoradpesquisaprefaturagfo/RECORD_FILTERING',
    applyedFilters
  ),
]);
